// Souvenir's real components (web/souvenir, copied from the design system), typed by its index.d.ts.
import "./react-global.ts";
import "../souvenir/bundle.js";
import type * as Souvenir from "../souvenir/index";

const S = (window as unknown as { Souvenir: typeof Souvenir }).Souvenir;

export const { Avatar, AvatarStack, Button, Chip, CrewPin, Icon, MapPin, SegmentedControl, Sheet, TextField } = S;
export type { IconName, PersonColor } from "../souvenir/index";
